// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.segmented-control {\n    display: flex;\n    flex-direction: row;\n    border-radius: 5px;\n}\n.segmented-item {\n    flex: 1;\n    padding: 10px;\n    transition: all .3s ease;\n    text-align: center;\n    user-select: none;\n}\n.segmented-item:last-child {\n    border: none!important;\n}\n.is-selected {\n    color: white;\n}\n", ""]);
// Exports
module.exports = exports;
